import store from '../store';
import * as actions from "./loginTypes";
import { handleAxiosPost, handleAxiosGet } from '../axiosHelper';

export const UserLogin = async (credentials) => {
    const url = '/Login/Login';
    const contentType = "application/json";
    const data = JSON.stringify(credentials);

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        localStorage.setItem("token", responseData?.token || "");
        localStorage.setItem("userName", responseData?.userName || "");
        localStorage.setItem("authenticated", true);
        localStorage.setItem("user", credentials?.userName || "");
        localStorage.setItem("firstTimeLogin", responseData?.firstTimeLogin === "Y");

        if (responseData?.cardCode && !responseData?.cardCode.includes(",")) {
            localStorage.setItem("cardCode", responseData?.cardCode || "");
            localStorage.setItem("cardName", responseData?.cardName || "");
        }

        return responseData;
    }
    else {
        return responseData;
    };
};

export const UserLogout = async () => {
    localStorage.clear();
};

export const sendResetPasswordMail = async (payload) => {
    const url = '/Login/SendResetPasswordMail';
    const contentType = "application/json";
    const data = payload;

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        return responseData;
    }
    else {
        return responseData;
    };
};

export const resetPassword = async (item) => {
    let url = '/Login/ResetPassword';
    let contentType = "application/json";
    let data = item;

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        return responseData;
    } else {
        return responseData;
    }
};

export const checkResetPasswordLink = async (item) => {
    let url = '/Login/CheckResetPasswordLink';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData.result) {
        return responseData;
    } else {
        return responseData;
    }
};

export const getUserCustomerList = async (item) => {
    let url = '/User/GetUserCustomerList';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETUSERCUSTOMERLIST, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};